import { Card, Tag, Typography as typography_antd } from "antd";
import CompanyPolicyStyle from "./CompanyPolicyStyle";
import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import DOMPurify from "dompurify";
import { Button, MenuItem, Select, Typography } from "@mui/material";
import env from "../../config/env";
import { fetchRoleData } from "../../redux/slice/getRoleData";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";

const { Title, Text } = typography_antd;
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

const CompanyPolicyuserlist = () => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const [roleData, setRoleData] = useState();
  const [companyPolicy, setCompanyPolicy] = useState("");
  const [defaultValue, setDefaultValue] = useState();
  const [loading, setloading] = useState(false);
  const [listValue, setListValue] = useState("");
  const [docId, setDocId] = useState("");
  const [status, setStatus] = useState();
  const [selectVal, setSelectVal] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  if (state?.getRoleData?.data?.status === 555 || state?.getRoleData?.data?.status === 501) {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    toast.error("Session expire, Please LogIn!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "1",
    });
    Navigate("/login")
  }
  const tempRoleData = state?.getRoleData.data?.data;

  useEffect(() => {
    dispatch(fetchRoleData(token));
  }, [token]);
  useEffect(() => {
    getRoleData();
  }, [tempRoleData]);
  const optionList = [];

  const getRoleData = async () => {
    tempRoleData &&
      tempRoleData.forEach((element) => {
        optionList.push({
          label: `${element.value}`,
          value: `${element.id}`,
        });
      });
    setRoleData(optionList);
    setDefaultValue(optionList[0].value);

    let optionListValue = 0;
    if (optionList.length > 0) {
      optionListValue = optionList[0].value;
    }
    todata(optionListValue);
  };

  const handleChange = (val) => {
    todata(val);
    setListValue(val);
    setSelectVal(val);
  };

  const todata = async (val) => {
    try {

      // Encrypt data
      const encryptedVal = CryptoJS.AES.encrypt(val.toString(), SECRET_KEY).toString();
      const encodedVal = encodeURIComponent(encryptedVal); // ✅ very important

      console.log(encodedVal, "ghghvfh")

      //Encrypt api endpoint
      const getPolicy = CryptoJS.SHA256("/getPolicy" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getPolicy}?roleId=${encodedVal}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        if (errorData.status === 404) {
          setCompanyPolicy("");
          setDocId("");
          setStatus("");
          setloading(true);
        }
      }
      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          const arr = [];
          const policy_status = [];

          decryptedData.forEach((element) => {
            arr.push(element.policy_details);
            setDocId(element.id);
            policy_status.push(element.status);
          });
          setCompanyPolicy(arr);
          setStatus(policy_status);
          setloading(true);
        }
      }
    } catch (error) {
      console.error("Error get Policy in:", error.message);
    }
  };

  const btnhandler = () => {
    let liValue = listValue == "" ? defaultValue : listValue;
    navigate("/companypolicy/updatecompanypolicy", {
      state: { liValue, docId },
    });
  };

  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }
  return (
    <CompanyPolicyStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "calc(100vh - 75px" }}
          className="card"
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          {loading ? (
            <>
              <div className="view_policy_title">
                <div className="Title_div formControl">
                  <Title
                    level={2}
                    style={{
                      color: "#244DA0",
                      fontFamily: "ImportedMilliardBold",
                      fontWeight: 500
                    }}
                  >
                    Company Policy
                  </Title>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    className="Select_role"
                    defaultValue={defaultValue}
                    value={selectVal}
                    onChange={(e) => handleChange(e.target.value)}
                  >
                    {roleData &&
                      roleData.map((role) => (
                        <MenuItem key={role.value} value={role.value}>
                          {role.label}
                        </MenuItem>
                      ))}
                  </Select>
                  {companyPolicy != "" ? (
                    <Tag color="orange" className="TagPolicy">
                      {status}
                    </Tag>
                  ) : (
                    ""
                  )}
                </div>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={btnhandler}
                  className="update_policy"
                  style={{ marginTop: "0px" }}
                >
                  Update Company Policy
                </Button>
              </div>
              <div>
                {companyPolicy == "" ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                      fontFamily: "ImportedMilliardSemibold",
                    }}
                  >
                    No Data
                  </div>
                ) : (
                  <div className="addScroll">
                    <div
                      className="preview"
                      // dangerouslySetInnerHTML={createMarkup(companyPolicy)}
                      dangerouslySetInnerHTML={{ __html: companyPolicy }}
                      style={{
                        fontFamily: "Milliard",
                        fontSize: "12pt",
                      }}
                    ></div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <span class="loader"></span>
          )}
        </Card>
      </div>
    </CompanyPolicyStyle>
  );
};
export default CompanyPolicyuserlist;
